export default __webpack_public_path__ + "static/media/th.7c611a57.png";